import { Navigate } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useClients } from './hooks/useClients';
import { useClientsPaginated } from './hooks/useClientsPaginated';

const NON_FINANCIAL_DATA_TAB = 'non-financial-data';

export function ClientRootRedirect() {
  const { flagEnabledPaginatedClients } = useFlags();
  const { clients } = useClients({}, { enabled: !flagEnabledPaginatedClients });
  const { items } = useClientsPaginated({}, { enabled: flagEnabledPaginatedClients });
  const firstClientId = flagEnabledPaginatedClients ? items[0]?.id : clients[0]?.id;
  if (!firstClientId) return <Navigate to="/clients/all" replace />;
  return <Navigate to={`/client/${firstClientId}/${NON_FINANCIAL_DATA_TAB}`} replace />;
}
